import styled, { css } from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';

const commonLinkStyles = css`
  transition: color 0.3s ease;

  &:hover {
    color: var(--custom-yellow);
  }
`;

export const FooterLink = styled(Typography).attrs({ variant: 'body3' })`
  color: var(--textAndLabels-tertiary);
  cursor: pointer;
  border: none;
  display: block;
  margin-bottom: 8px;
  ${commonLinkStyles}
`;
